// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1UQsY","itemTitle":"ClientEmergencyInfo_itemTitle__3Bs0g","itemText":"ClientEmergencyInfo_itemText__1yhhg"};